/**
 * WalletConnect default-export interop shim.
 *
 * Some bundlers (Angular esbuild + IPFS merge step) resolve
 * `@walletconnect/universal-provider` as `{ default: { default: Class } }`
 * which breaks AppKit's `UniversalProvider.init()` call.
 *
 * Import the real package via a direct path so this file is not aliased to itself.
 */
// @ts-expect-error direct file import bypasses tsconfig alias circularity
import * as universalProviderModule from '../../../node_modules/@walletconnect/universal-provider/dist/index.js';

interface UniversalProviderStatic {
  init: (options: Record<string, unknown>) => Promise<unknown>;
}

function resolveUniversalProviderClass(): UniversalProviderStatic {
  const mod = universalProviderModule as typeof universalProviderModule & {
    UniversalProvider?: UniversalProviderStatic;
  };

  if (typeof mod.default?.init === 'function') {
    return mod.default;
  }

  if (typeof mod.UniversalProvider?.init === 'function') {
    return mod.UniversalProvider;
  }

  const nested = (mod.default as { default?: UniversalProviderStatic } | undefined)?.default;
  if (typeof nested?.init === 'function') {
    return nested;
  }

  throw new Error('Unable to resolve UniversalProvider.init from @walletconnect/universal-provider');
}

const UniversalProvider = resolveUniversalProviderClass();

export default UniversalProvider;
export { UniversalProvider };
